import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from 'react-toastify';

export const GetDemoDomainsWT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getDemoDomainsWT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_DEMO_CERTIFY_DOMAINS_WT, payload: data.data });
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const CreateDemoDomainWT = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.createDemoDomainWT(formData);
    if (status === 201) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to create domain");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const UpdateDemoDomainWT = (id, formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.updateDemoDomainWT(id, formData);
    if (status === 202) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to update domain");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const DeleteDemoDomainWT = (id, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.deleteDemoDomainWT(id);
    if (status === 202) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to delete domain");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
